export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      about: 'Sobre mí',
      methodology: 'Metodología',
      pricing: 'Tarifas',
      blog: 'Blog',
      book: 'Reservar Clase',
      resources: 'Recursos',
      podcast: 'Podcast',
      testimonials: 'Testimonios',
      contact: 'Contacto',
      cta: 'Reserva tu clase de prueba'
    },
    hero: {
      title: 'Aprende español de forma natural, fluida y a tu ritmo',
      subtitle: 'Clases de español online personalizadas para estudiantes de todos los niveles. Conecta con el idioma desde la primera sesión.',
      cta: 'Reservar clase de prueba'
    },
    about: {
      title: 'Hola, soy Cecilia',
      subtitle: 'Tu profesora de español',
      description: 'Llevo más de 10 años enseñando español a alumnos de diferentes países y niveles. Soy profesora nativa y examinadora DELE.\n\nPero para mí aprender español no consiste únicamente en estudiar gramática. Quiero que tengas un espacio en el que puedas hablar, equivocarte, preguntar y practicar sin sentirte juzgado/a.\n\nPor eso preparo las clases teniendo en cuenta tu nivel, tus intereses y, sobre todo, para qué necesitas el español. Empezamos donde estás y avanzamos hacia donde quieres llegar.',
      credentials: 'Examinadora DELE certificada y especialista en preparación de pruebas SIELE',
      quote: 'Aprender un idioma no es solo memorizar gramática, es abrir la puerta a una nueva forma de vivir y comunicarte.'
    },
    methodology: {
      title: 'Clases adaptadas a ti',
      subtitle: 'Mi enfoque de enseñanza',
      cards: [
        {
          title: 'Habla más',
          description: 'Al ser una clase individual tendrás mucho más tiempo para hablar, practicar y ganar confianza.'
        },
        {
          title: 'Corrige tus errores',
          description: 'Trabajaremos los errores que realmente cometes para ayudarte a expresarte de forma cada vez más clara y natural.'
        },
        {
          title: 'Aprende español útil',
          description: 'Trabajaremos vocabulario, gramática, pronunciación y comprensión a partir de tus objetivos y situaciones reales.'
        },
        {
          title: 'Avanza con un objetivo claro',
          description: 'Las clases se adaptan a tu nivel, tus intereses y a aquello que quieres conseguir con el español.'
        }
      ]
    },
    booking: {
      title: 'Tu primera clase es gratis',
      subtitle: 'Elige tu tipo de clase',
      lead: '30 minutos para conocernos y descubrir cómo puedes mejorar tu español',
      intro: 'No tienes que decidir ahora cuántas clases quieres hacer ni qué tipo de curso necesitas. Primero nos conocemos, vemos cuál es tu situación y después decides si quieres continuar.',
      note: 'Después tú decides si quieres continuar. Sin compromiso.',
      types: [
        {
          name: 'Clase de Prueba',
          duration: '30 minutos',
          description: 'Conoce mi metodología y define tus objetivos',
          price: 'Gratis'
        },
        {
          name: 'Clase Individual',
          duration: '50 minutos',
          description: 'Clase de conversación personalizada',
          price: 'Consultar'
        },
        {
          name: 'Paquete Intensivo',
          duration: '5 clases',
          description: 'Gramática y preparación de exámenes',
          price: 'Consultar'
        }
      ],
      selectDate: 'Selecciona fecha y hora',
      selectTime: 'Selecciona la hora',
      selectClassType: 'Selecciona tu tipo de clase',
      yourData: 'Tus datos de contacto',
      nameLabel: 'Nombre completo',
      namePlaceholder: 'Tu nombre',
      emailLabel: 'Correo electrónico',
      emailPlaceholder: 'tu@email.com',
      messageLabel: 'Mensaje (opcional)',
      messagePlaceholder: 'Cuéntame tus objetivos...',
      sending: 'Enviando...',
      errorFields: 'Por favor completa tu nombre y correo electrónico',
      errorDateTime: 'Por favor selecciona fecha y hora',
      errorAllFields: 'Por favor completa todos los campos requeridos (nombre, email válido, fecha y hora).',
      errorSubmit: 'Hubo un error al enviar tu reserva. Inténtalo de nuevo.',
      errorProcessing: 'Hubo un error al procesar tu reserva. Por favor intenta de nuevo.',
      errorSlotTaken: 'Esta hora ya está reservada. Elige otra.',
      noSlots: 'No hay horarios disponibles para este día. Por favor elige otra fecha.',
      processing: 'Procesando...',
      successTitle: '¡Reserva Confirmada!',
      successMessage: 'Tu clase ha sido reservada para el',
      successAt: 'a las',
      successContact: 'Me pondré en contacto contigo por email',
      successContactSuffix: 'para confirmar los detalles y coordinar el pago.',
      successNote: 'Recibirás un email de confirmación pronto.',
      confirm: 'Confirmar reserva'
    },
    resources: {
      title: '¿Quieres seguir practicando español?',
      subtitle: 'Recursos gratuitos',
      lead: 'También puedes encontrar recursos gratuitos para practicar español por tu cuenta.',
      filters: {
        all: 'Todos',
        grammar: 'Gramática',
        vocabulary: 'Vocabulario',
        exercises: 'Ejercicios',
        guides: 'Guías'
      },
      download: 'Descargar PDF',
      downloadsLabel: 'descargas',
      emptyState: 'No hay recursos disponibles para este filtro'
    },
    testimonials: {
      title: 'Lo que dicen mis alumnos',
      subtitle: 'Testimonios',
      lead: 'Aprender español también puede sentirse cómodo, natural y motivador.'
    },
    footer: {
      rights: 'Todos los derechos reservados',
      privacy: 'Política de privacidad',
      terms: 'Términos del servicio',
      legal: 'Aviso legal'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About Me',
      methodology: 'Methodology',
      pricing: 'Pricing',
      blog: 'Blog',
      book: 'Book a Class',
      resources: 'Resources',
      podcast: 'Podcast',
      testimonials: 'Testimonials',
      contact: 'Contact',
      cta: 'Book Your Trial Class'
    },
    hero: {
      title: 'Learn Spanish naturally, fluently, and at your own pace',
      subtitle: 'Personalized online Spanish classes for students of all levels. Connect with the language from the first session.',
      cta: 'Book Trial Class'
    },
    about: {
      title: 'Your online Spanish teacher',
      subtitle: 'Meet your teacher',
      description: 'I am Cecilia Mateo García, and my passion is teaching Spanish and connecting with cultures from around the world. With over 10 years of experience, I hold a degree in Geography with a Master in Education, and I specialized in teaching Spanish as a foreign language.',
      credentials: 'Certified DELE examiner and SIELE test preparation specialist',
      quote: 'Learning a language is not just about memorizing grammar; it\'s about opening the door to a new way of living and communicating.'
    },
    methodology: {
      title: 'What are my online Spanish lessons like?',
      subtitle: 'My teaching approach',
      cards: [
        {
          title: 'Real Conversation',
          description: 'Practical communicative approach from day one. You will speak Spanish from the first class.'
        },
        {
          title: '100% Personalized',
          description: 'Adapted to your goals: travel, work, DELE exams or fluent conversation.'
        },
        {
          title: 'Total Flexibility',
          description: 'Schedules adapted to your time zone and lifestyle.'
        },
        {
          title: 'Materials Included',
          description: 'No need to buy expensive books; all materials are digitalized and updated.'
        }
      ]
    },
    booking: {
      title: 'Book Your Class',
      subtitle: 'Choose your class type',
      types: [
        {
          name: 'Trial Class',
          duration: '30 minutes',
          description: 'Get to know my methodology and define your goals',
          price: 'Free'
        },
        {
          name: 'Individual Class',
          duration: '50 minutes',
          description: 'Personalized conversation class',
          price: 'Inquire'
        },
        {
          name: 'Intensive Package',
          duration: '5 classes',
          description: 'Grammar and exam preparation',
          price: 'Inquire'
        }
      ],
      selectDate: 'Select date and time',
      selectTime: 'Select time',
      selectClassType: 'Choose your class type',
      yourData: 'Your contact details',
      nameLabel: 'Full name',
      namePlaceholder: 'Your name',
      emailLabel: 'Email address',
      emailPlaceholder: 'you@email.com',
      messageLabel: 'Message (optional)',
      messagePlaceholder: 'Tell me your goals...',
      sending: 'Sending...',
      errorFields: 'Please enter your name and email',
      errorDateTime: 'Please select date and time',
      errorAllFields: 'Please complete all required fields (name, valid email, date and time).',
      errorSubmit: 'There was an error submitting your booking. Please try again.',
      errorProcessing: 'There was an error processing your booking. Please try again.',
      errorSlotTaken: 'This time slot is already booked. Please choose another.',
      noSlots: 'No time slots available for this day. Please choose another date.',
      processing: 'Processing...',
      successTitle: 'Booking Confirmed!',
      successMessage: 'Your class has been booked for',
      successAt: 'at',
      successContact: 'I will contact you by email',
      successContactSuffix: 'to confirm the details and arrange payment.',
      successNote: 'You will receive a confirmation email soon.',
      confirm: 'Confirm booking'
    },
    resources: {
      title: 'Resources and Materials',
      subtitle: 'Learning library',
      filters: {
        all: 'All',
        grammar: 'Grammar',
        vocabulary: 'Vocabulary',
        exercises: 'Exercises',
        guides: 'Guides'
      },
      download: 'Download PDF',
      downloadsLabel: 'downloads',
      emptyState: 'No resources available for this filter'
    },
    testimonials: {
      title: 'Testimonials',
      subtitle: 'What my students say'
    },
    footer: {
      rights: 'All rights reserved',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      legal: 'Legal Notice'
    }
  },
  de: {
    nav: {
      home: 'Startseite',
      about: 'Über mich',
      methodology: 'Methodik',
      pricing: 'Tarife',
      blog: 'Blog',
      book: 'Unterricht buchen',
      resources: 'Ressourcen',
      podcast: 'Podcast',
      testimonials: 'Bewertungen',
      contact: 'Kontakt',
      cta: 'Buche deine Probestunde'
    },
    hero: {
      title: 'Lerne Spanisch natürlich, fließend und in deinem eigenen Tempo',
      subtitle: 'Personalisierter Online-Spanischunterricht für Schüler aller Niveaus. Verbinde dich mit der Sprache ab der ersten Stunde.',
      cta: 'Probestunde buchen'
    },
    about: {
      title: 'Deine Spanischlehrerin online',
      subtitle: 'Lerne deine Lehrerin kennen',
      description: 'Ich bin Cecilia Mateo García, und meine Leidenschaft ist es, Spanisch zu unterrichten und mich mit Kulturen aus der ganzen Welt zu verbinden. Mit über 10 Jahren Erfahrung habe ich ein Studium der Geografie mit einem Master in Pädagogik und habe mich auf das Unterrichten von Spanisch als Fremdsprache spezialisiert.',
      credentials: 'Zertifizierte DELE-Prüferin und SIELE-Testvorbereitungsspezialistin',
      quote: 'Eine Sprache zu lernen bedeutet nicht nur, Grammatik auswendig zu lernen; es bedeutet, die Tür zu einer neuen Art des Lebens und Kommunizierens zu öffnen.'
    },
    methodology: {
      title: 'Wie läuft mein Spanischunterricht online ab?',
      subtitle: 'Mein Unterrichtsansatz',
      cards: [
        {
          title: 'Echte Konversation',
          description: 'Praktischer kommunikativer Ansatz vom ersten Tag an. Du sprichst Spanisch ab der ersten Stunde.'
        },
        {
          title: '100% Personalisiert',
          description: 'Angepasst an deine Ziele: Reisen, Arbeit, DELE-Prüfungen oder fließende Konversation.'
        },
        {
          title: 'Totale Flexibilität',
          description: 'Zeitpläne angepasst an deine Zeitzone und deinen Lebensstil.'
        },
        {
          title: 'Materialien Inklusive',
          description: 'Keine teuren Bücher kaufen müssen; alle Materialien sind digitalisiert und aktualisiert.'
        }
      ]
    },
    booking: {
      title: 'Buche deinen Unterricht',
      subtitle: 'Wähle deinen Unterrichtstyp',
      types: [
        {
          name: 'Probestunde',
          duration: '30 Minuten',
          description: 'Lerne meine Methodik kennen und definiere deine Ziele',
          price: 'Kostenlos'
        },
        {
          name: 'Einzelunterricht',
          duration: '50 Minuten',
          description: 'Personalisierter Konversationsunterricht',
          price: 'Anfragen'
        },
        {
          name: 'Intensivpaket',
          duration: '5 Stunden',
          description: 'Grammatik und Prüfungsvorbereitung',
          price: 'Anfragen'
        }
      ],
      selectDate: 'Datum und Uhrzeit auswählen',
      selectTime: 'Uhrzeit auswählen',
      selectClassType: 'Wähle deinen Unterrichtstyp',
      yourData: 'Deine Kontaktdaten',
      nameLabel: 'Vollständiger Name',
      namePlaceholder: 'Dein Name',
      emailLabel: 'E-Mail-Adresse',
      emailPlaceholder: 'du@email.com',
      messageLabel: 'Nachricht (optional)',
      messagePlaceholder: 'Erzähl mir von deinen Zielen...',
      sending: 'Wird gesendet...',
      errorFields: 'Bitte gib deinen Namen und deine E-Mail ein',
      errorDateTime: 'Bitte wähle Datum und Uhrzeit',
      errorAllFields: 'Bitte fülle alle erforderlichen Felder aus (Name, gültige E-Mail, Datum und Uhrzeit).',
      errorSubmit: 'Bei der Übermittlung deiner Buchung ist ein Fehler aufgetreten. Bitte versuche es erneut.',
      errorProcessing: 'Bei der Bearbeitung deiner Buchung ist ein Fehler aufgetreten. Bitte versuche es erneut.',
      errorSlotTaken: 'Diese Uhrzeit ist bereits gebucht. Bitte wähle eine andere.',
      noSlots: 'Für diesen Tag sind keine Zeiten verfügbar. Bitte wähle ein anderes Datum.',
      processing: 'Wird bearbeitet...',
      successTitle: 'Buchung Bestätigt!',
      successMessage: 'Dein Unterricht wurde gebucht für',
      successAt: 'um',
      successContact: 'Ich werde dich per E-Mail kontaktieren',
      successContactSuffix: 'um die Details zu bestätigen und die Zahlung zu vereinbaren.',
      successNote: 'Du erhältst bald eine Bestätigungs-E-Mail.',
      confirm: 'Buchung bestätigen'
    },
    resources: {
      title: 'Ressourcen und Materialien',
      subtitle: 'Lernbibliothek',
      filters: {
        all: 'Alle',
        grammar: 'Grammatik',
        vocabulary: 'Vokabular',
        exercises: 'Übungen',
        guides: 'Leitfäden'
      },
      download: 'PDF herunterladen',
      downloadsLabel: 'Downloads',
      emptyState: 'Keine Ressourcen für diesen Filter verfügbar'
    },
    testimonials: {
      title: 'Bewertungen',
      subtitle: 'Was meine Schüler sagen'
    },
    footer: {
      rights: 'Alle Rechte vorbehalten',
      privacy: 'Datenschutzrichtlinie',
      terms: 'Nutzungsbedingungen',
      legal: 'Impressum'
    }
  }
};